import React from 'react'

function LoginModal({title,description}) {
  return (
    <div>
      <div className="notification-overlay ">
      <div className="notification-modal flex flex-col justify-center items-center rounded-xl">
        <span className="title">{title}</span>
        <p className="loading-paragraph">
          {description}
        </p>
      </div>
    </div>
    </div>
  )
}

export default LoginModal
